import React, { useState, useEffect } from "react";

const DateTimeDisplay = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update time every minute
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    // Cleanup interval on unmount
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return (
      new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        // timeZone: "CST",
        timeZone: "America/Chicago",
      })
        .format(date)
        .replace(",", "") + " CST"
    );
  };

  return (
    <div className="inline-flex items-center gap-2 text-white px-3 py-4 datepicker-col">
      <span className="font-mono text-sm tracking-wide hidden  lg:block">
        {formatDate(currentTime).replace(",", " |")}
      </span>
      {/* <CalendarMinus2 className="size-5 text-emerald-400" /> */}

      <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full secondmenu">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_15_9744)">
            <path
              d="M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"
              fill="#48BA89"
            />
          </g>
          <defs>
            <clipPath id="clip0_15_9744">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default DateTimeDisplay;
